// servicios auditoria
import { TrazabilidadService } from '@/modules/Core/services/TrazabilidadService'
import { AuditoriaFinancieraService } from '@/modules/Financiera/services/AuditoriaFinancieraService'
import { PantallaOperadorService } from '@/modules/Pantalla/services/PantallaOperadorService'
import { PantallaDispositivoService } from '@/modules/Pantalla/services/PantallaDispositivoService'
import { SoporteTicketService } from '@/modules/Soporte/services/SoporteTicketService'
import { SolicitudPerfilService } from '@/modules/Portal/services/SolicitudPerfilService'
import { ConfiguracionPortalService } from '@/modules/Portal/services/ConfiguracionPortalService'
import { LogFrontendService } from '@/modules/Core/services/LogFrontendService'
// servicios autenticacion
import { PerfilesService } from '@/modules/Autenticacion/services/PerfilesService'
import { PermisosService } from '@/modules/Autenticacion/services/PermisosService'
import { AuthService } from '@/modules/Autenticacion/services/AuthService'
// servicios config
import { MaestraService } from '@/modules/Configuracion/services/MaestraService'
import { MaestraComunService } from '@/modules/Configuracion/services/MaestraComunService'
import { ReporteService } from '@/modules/Reportes/services/ReporteService'
import { EntidadService } from '@/modules/Configuracion/services/EntidadService'
import { EntidadRelacionadosService } from '@/modules/Configuracion/services/EntidadRelacionadosService'
import { PersonaService } from '@/modules/Administracion/services/PersonaService'
import { OdontogramaService } from '@/modules/Configuracion/services/OdontogramaService'
import { OdontogramaConvencionesService } from '@/modules/Configuracion/services/OdontogramaConvencionesService'
import { ContenidoPublicitarioService } from '@/modules/Configuracion/services/ContenidoPublicitarioService'
import { UserService } from '@/modules/Configuracion/services/UserService'
import { FormularioService } from '@/modules/Configuracion/services/FormularioService'
import { FuncionService } from '@/modules/Configuracion/services/FuncionService'
import { ConfiguracionServicios } from '@/modules/Configuracion/services/ConfiguracionService'
import { ConfiguracionComunService } from '@/modules/Configuracion/services/ConfiguracionComunService'
import { InteroperabilidadService } from '@/modules/Configuracion/services/InteroperabilidadService'
import { BasedatosService } from '@/modules/Administracion/services/BasedatosService'
import { BasedatosPacientesService } from '@/modules/Administracion/services/BasedatosPacientesService'
import { ContratoService } from '@/modules/Contratacion/services/ContratoService'
import { ServicioService } from '@/modules/Contratacion/services/ServicioService'
import { ServicioEmpleadoService } from '@/modules/Administracion/services/ServicioEmpleadoService'
import { HorarioService } from '@/modules/Administracion/services/HorarioService'
import { PersonaEmpleadoVincuService } from '@/modules/Financiera/services/PersonaEmpleadoVincuService'
import { PaqueteService } from '@/modules/Contratacion/services/PaqueteService'
import { DivipolaService } from '@/modules/Configuracion/services/DivipolaService'
import { CupService } from '@/modules/Contratacion/services/CupService'
import { MetasService } from '@/modules/Contratacion/services/MetasService'
import { TarifarioService } from '@/modules/Contratacion/services/TarifarioService'
import { ContratoxservicioService } from '@/modules/Contratacion/services/ContratoxservicioService'
import { TrashService } from '@/modules/Configuracion/services/TrashService'
import { NotificacionPushService } from '@/modules/Core/services/NotificacionPushService'
import { HeaderCupsService } from '@/modules/Administracion/services/headerCupsService'
import { JABotService } from '@/modules/Core/services/JABotService'
import { ComponentTypeServicios} from '@/modules/Configuracion/services/ComponentTypeService'
import { NotificacionEmailService } from '@/modules/Core/services/NotificacionEmailService'
import { LicenciaService } from '@/modules/Configuracion/services/LicenciaService'
import { PlanesService } from '@/modules/Configuracion/services/PlanesService'
import { AnaliticaService } from '@/modules/Analitica/services/AnaliticaService'
import { DocJsonService } from '@/modules/Configuracion/services/DocJsonService'
import { DocJsonComunService } from '@/modules/Configuracion/services/DocJsonComunService'
// servicios cita
import { AnexoService } from '@/modules/Asistencial/services/AnexoService'
import { AgendamientoService } from '@/modules/Agendamiento/services/AgendamientoService'
import { CaptacionService } from '@/modules/Agendamiento/services/CaptacionService'
import { OrdenesTecnologiaService } from '@/modules/Admision/services/OrdenesTecnologiaService'
import { DisponibilidadService } from '@/modules/Agendamiento/services/DisponibilidadService'
import { OdontologicaService } from '@/modules/Asistencial/services/OdontologicaService'
import { AdmisionService } from '@/modules/Admision/services/AdmisionService'
import { FormCompValueService } from '@/modules/Asistencial/services/FormCompValueService'
import { HistoricoPacienteService } from '@/modules/Asistencial/services/HistoricoPacienteService'
import { AlertasService } from '@/modules/Asistencial/services/AlertasService'
// servicios facturacion
import { CuentaCobroService } from '@/modules/Financiera/services/CuentaCobroService'
import { NumeracionDianService } from '@/modules/Financiera/services/NumeracionDianService'
import { FacturaService } from '@/modules/Financiera/services/FacturaService'
import { JSONRipsService } from '@/modules/Financiera/services/JSONRipsService'
import { ResponseDianService } from '@/modules/Financiera/services/ResponseDianService'
// servicios asistenciales
import { AsistencialOrdenesService } from '@/modules/Asistencial/services/AsistencialOrdenesService'
import { HistoriaGraficaService } from '@/modules/Asistencial/services/HistoriaGraficaService'
// servicios medicamentos
import { MedicamentoService } from '@/modules/Farmacia/services/MedicamentoService'
import { TransaccionesService } from '@/modules/Farmacia/services/TransaccionesService'

// servicios administracion
import { LogService } from '@/modules/Administracion/services/LogService'
import { HojaVidaService } from '@/modules/Administracion/services/HojaVidaService'
import { ComponentService } from '@/modules/Configuracion/services/ComponentService'

// servicios de tarea
import { TareaService } from '@/modules/Core/services/TareaService'
import { EntidadSolicitudService } from '@/modules/Configuracion/services/EntidadSolicitudService'
import { SolicitudMedicamentoService } from '@/modules/Farmacia/services/SolicitudMedicamentoService'
import { CalendarioAdminService } from '@/modules/Administracion/services/CalendarioAdminService'
import { AlertAutomatizacionesService } from '@/modules/Administracion/services/AlertAutomatizacionesService'
import { AlertCondicionesService } from '@/modules/Administracion/services/AlertCondicionesService'
import { MotivosService } from '@/modules/Configuracion/services/MotivosService'
import { MedicamentoActaService } from '@/modules/Farmacia/services/MedicamentoActaService'
import { LotesService } from '@/modules/Farmacia/services/LotesService'
import { DocJsonDiligenciadosService } from '@/modules/Asistencial/services/DocJsonDiligenciadosService'
import { MedicamentoGenericoService } from '@/modules/Farmacia/services/MedicamentoGenericoService'
import { EquivalenciasService } from '@/modules/Farmacia/services/EquivalenciasService'
import { ExtramuralService } from '@/modules/Asistencial/services/ExtramuralService'
import { ConsiderandosService } from '@/modules/Configuracion/services/ConsiderandosService'
import { PlantillasHCService } from '@/modules/PlantillasHC/services/PlantillasHCService'

import { DemandaInducidaDashboardService, DemandaInducidaAnalyticsService } from '@/modules/DemandaInducida/services/DemandaInducidaDahboardService'
import { DemandaInducidaGestionService } from '@/modules/Administracion/services/DemandaInducidaGestionService'
import { NovedadService } from '@/modules/Admision/services/NovedadService'
import { KioscoDispositivoService } from '@/modules/Admision/services/KioscoDispositivoService'
import { KioscoCategoriaService } from '@/modules/Administracion/services/KioscoCategoriaService'
import { RecursoService } from '@/modules/Respositorios/services/RecursoService'
import { DocumentosFacturacionService } from '@/modules/Facturacion/services/DocumentosFacturacionService'
import { LogsFacturacionService } from '@/modules/Facturacion/services/LogsFacturacionService'
import { ConsultasFacturacionService } from '@/modules/Facturacion/services/ConsultasFacturacionService'

// Exportación de instancias
export const perfilService = new PerfilesService()
export const permisoService = new PermisosService()
export const authService = new AuthService()

export const maestraService = new MaestraService()
export const maestraComunService = new MaestraComunService()
export const reporteService = new ReporteService()
export const entidadService = new EntidadService()
export const entidadSolicitudService = new EntidadSolicitudService()
export const entidadRelacionadosService = new EntidadRelacionadosService()
export const personaService = new PersonaService()
export const odontogramaService = new OdontogramaService()
export const odontogramaConvencionesService = new OdontogramaConvencionesService()
export const contenidoPublicitarioService = new ContenidoPublicitarioService()
export const userService = new UserService()
export const formularioServicios = new FormularioService()
export const configuracionServicios = new ConfiguracionServicios()
export const configuracionComunServicios = new ConfiguracionComunService()

export const basedatosService = new BasedatosService()
export const basedatosPacientesService = new BasedatosPacientesService()
export const contratoService = new ContratoService()
export const servicioService = new ServicioService()
export const servicioEmpleadoService = new ServicioEmpleadoService()
export const horarioService = new HorarioService()
export const personaEmpleadoVincuService = new PersonaEmpleadoVincuService()
export const paqueteService = new PaqueteService()
export const divipolaService = new DivipolaService()
export const anexoService = new AnexoService()
export const hojaVidaService = new HojaVidaService()
export const agendamientoService = new AgendamientoService()
export const captacionService = new CaptacionService()
export const ordenesTecnologiaService = new OrdenesTecnologiaService()
export const disponibilidadService = new DisponibilidadService()
export const odontologicaService = new OdontologicaService()
export const admisionService = new AdmisionService()
export const novedadService = new NovedadService()
export const kioscoDispositivoService = new KioscoDispositivoService()
export const kioscoCategoriaService = new KioscoCategoriaService()
export const motivoService = new MotivosService()
export const cupService = new CupService()
export const tarifarioService = new TarifarioService()
export const contratoxservicioService = new ContratoxservicioService()
export const trashService = new TrashService()
export const headerCupsService = new HeaderCupsService()
export const jABotService = new JABotService()
export const formCompValueService = new FormCompValueService()
export const historicoPacienteService = new HistoricoPacienteService()
export const componentTypeServicios = new ComponentTypeServicios()
export const funcionService = new FuncionService()
export const asistencialOrdenesService = new AsistencialOrdenesService()
export const considerandosService = new ConsiderandosService()
export const solicitudMedicamentoService = new SolicitudMedicamentoService()
export const cuentaCobroService = new CuentaCobroService()
export const jsonRipsService = new JSONRipsService()
export const numeracionDianService = new NumeracionDianService()
export const responseDianService = new ResponseDianService()
export const facturaService = new FacturaService()
export const notificacionEmailService = new NotificacionEmailService()
export const componentService = new ComponentService()
export const metasService = new MetasService()
export const licenciaService = new LicenciaService()
export const planesService = new PlanesService()
export const analiticaService = new AnaliticaService()
export const docJsonService = new DocJsonService()
export const docJsonComunService = new DocJsonComunService()
export const notificacionPushService = new NotificacionPushService()
export const docJsonDiligenciadosService = new DocJsonDiligenciadosService()
export const interoperabilidadService = new InteroperabilidadService()
export const extramuralService = new ExtramuralService()
export const plantillasHCService = new PlantillasHCService()

export const medicamentoService = new MedicamentoService()
export const lotesService = new LotesService()
export const medicamentoActasService = new MedicamentoActaService()
export const transaccionesService = new TransaccionesService()
export const medicamentogenericoService = new MedicamentoGenericoService()
export const equivalenciasService = new EquivalenciasService()

export const recursoService = new RecursoService()
export const documentosFacturacionService = new DocumentosFacturacionService()
export const logsFacturacionService = new LogsFacturacionService()
export const consultasFacturacionService = new ConsultasFacturacionService()

// exportacion de servicios administracion
export const logService = new LogService()
export const historiaGraficaService = new HistoriaGraficaService()

// exportacion de servicios de tarea
export const tareaService = new TareaService()
export const alertasService = new AlertasService()
export const calendarioAdminService = new CalendarioAdminService()
export const alertAutomatizacionesService = new AlertAutomatizacionesService()
export const alertCondicionesService = new AlertCondicionesService()

export const demandaInducidaDashboardService = new DemandaInducidaDashboardService()
export const demandaInducidaAnalyticsService = new DemandaInducidaAnalyticsService()
export const demandaInducidaService = new DemandaInducidaGestionService()
export const trazabilidadService = new TrazabilidadService()
export const auditoriaFinancieraService = new AuditoriaFinancieraService()
export const pantallaOperadorService = new PantallaOperadorService()
export const pantallaDispositivoService = new PantallaDispositivoService()
export const logFrontendService = new LogFrontendService()

export const soporteTicketService = new SoporteTicketService()
export const solicitudPerfilService = new SolicitudPerfilService()
export const configuracionPortalService = new ConfiguracionPortalService()
